const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the content host Assignmentscomponent
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('contentHostAssignments', ['Application', 'Authorization', 'AdminAssignments', 'Assignments', 'AdminUsers', '$translate', function(Application, Authorization, AdminAssignments, Assignments, AdminUsers, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope:{},
      template: require('../../templates/directives/content-host-assignments.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.translations = {};
          self.sortName = 'completed_date';
          self.sortOrder = -1;
          self.filter = {
            page: null,
            per_page: 20,
            'assignee-populate': 'first_name,last_name,email,full_name,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
            'assignee.linked_locations-populate': 'name',
            'assignee.linked_departments-populate': 'name',
            fields: 'assignee,completed,completed_date,passed_failed_status,seconds_spent,progress,createdAt,due_date,assigned_content,completed_content',
            sort: self.sortName + ',' + self.sortOrder
          };
          self.smart_filter = {};
          self.unfiltered_assignments = [];
          self.selectionDirectory = {};
          self.selections = {
            select: function(item) {
              var id = item._id;
              if (self.selectionDirectory[id]) {
                delete self.selectionDirectory[id];
              } else {
                self.selectionDirectory[id] = item;
              }
              var type = self.contentType === 'video' || self.contentType === 'file' ? 'media' : self.contentType;
              self.searchItems.csv_selected = Application.API + '/learn/v3/assignments/csv?authtoken=' + Authorization.getAuthToken().authtoken + '&content_type=' + type + '&content_id=' + self.contentId;
              var ids = [];
              for (var id in self.selectionDirectory) {
                ids.push(self.selectionDirectory[id].assignee._id.toString());
              }
              self.searchItems.csv_selected += '&assignee=$in,' + ids.length + ',' + ids.join(',');
            },
            isChecked: function(item) {
              if (!item || !item._id) {
                return false;
              }
              return self.selectionDirectory[item._id] ? true : false;
            },
            clear: function() {
              self.selectionDirectory = {};
            }
          };
          self.searchItems = {
            placeholder: self.translations['contentHostAssign.search_placeholder'],
            onQuery: function(query_arguments) {
              self.smart_filter = {};
              self.searching = false;
              if (query_arguments && typeof query_arguments === 'object' && Object.keys(query_arguments).length) {
                self.searching = true;
              }
              var type = self.contentType === 'video' || self.contentType === 'file' ? 'media' : self.contentType;
              self.searchItems.csv_filtered = Application.API + '/learn/v3/assignments/csv?authtoken=' + Authorization.getAuthToken().authtoken + '&content_type=' + type + '&content_id=' + self.contentId;
              self.searchItems.csv_selected = Application.API + '/learn/v3/assignments/csv?authtoken=' + Authorization.getAuthToken().authtoken + '&content_type=' + type + '&content_id=' + self.contentId;

              if (!query_arguments || (typeof query_arguments === 'object' && Object.keys(query_arguments).length === 0)) {
                self.contentType = self.parseUrl();
                self.filter = {
                  page: 1,
                  per_page: 20,
                  'assignee-populate': 'first_name,last_name,email,full_name,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
                  'assignee.linked_locations-populate': 'name',
                  'assignee.linked_departments-populate': 'name',
                  fields: 'assignee,completed,completed_date,passed_failed_status,seconds_spent,progress,createdAt',
                  sort: self.sortName + ',' + self.sortOrder
                };
                self.filter['assigned_content.content_id'] = self.contentId;
                self.loadItems();
                return;
              }
              for (var key in query_arguments) {
                var newKey = key;
                if (key === 'privacy_grades') {
                  newKey = 'privacy_grade';
                }
                if (key === 'privacy_org_levels') {
                  newKey = 'privacy_org_level';
                }
                self.smart_filter[newKey.replace('privacy_', 'linked_').replace('name', 'full_name')] = query_arguments[key];
              }
              self.searching = true;
              self.searchLoading = true;

              var merged_filter_copy = Object.assign({}, {
                fields: '_id,first_name,last_name,full_name,email,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
                'linked_locations-populate': 'name',
                'linked_departments-populate': 'name',
                page: 1,
                per_page: 50
              }, self.smart_filter);

              AdminUsers.find(merged_filter_copy).$promise.then(function(users) {
                var ids = users.map(function(user) {
                  return user._id;
                });
                var length = ids.length;
                ids = ids.join(',');

                self.filter.page = 1;
                delete self.filter.completed;
                var type = self.contentType === 'video' || self.contentType === 'file' ? 'media' : self.contentType;
                self.searchItems.csv_filtered = Application.API + '/learn/v3/assignments/csv?authtoken=' + Authorization.getAuthToken().authtoken + '&content_type=' + type + '&content_id=' + self.contentId;
                self.searchItems.csv_selected = Application.API + '/learn/v3/assignments/csv?authtoken=' + Authorization.getAuthToken().authtoken + '&content_type=' + type + '&content_id=' + self.contentId;
                // Assignee
                self.filter.assignee = '$in,' + length + ',' + ids;
                self.searchItems.csv_filtered += '&assignee=$in,' + length + ',' + ids;
                self.searchItems.csv_selected += '&assignee=$in,' + length + ',' + ids;
                self.selections.clear();
                self.loadItems();
              });
            },
            csv_filtered: '',
            csv_selected: ''
          };
          self.typeDisplay = function(type) {
            var str = '';
            if (type === 'imported_content') {
              str = 'content';
            } else if (type === 'scorm') {
              str = 'SCORM content';
            } else {
              str = type.charAt(0).toUpperCase() + type.slice(1);
            }
            return str;
          };
          var params = Application.navigation.getRouteParameters();
          self.contentId = params.id;
          self.parseUrl = function() {
            var url = Application.navigation.getPath();
            if (/articles/g.test(url)) {
              return 'article';
            }
            if (/videos/g.test(url)) {
              return 'video';
            }
            if (/files/g.test(url)) {
              return 'file';
            }
            if (/scorm/g.test(url)) {
              return 'scorm';
            }
            if (/track/g.test(url)) {
              return 'track';
            }
            if (/assessment/g.test(url)) {
              return 'assessment';
            }
            if (/imported-content/g.test(url)) {
              return 'imported_content';
            }
            if (/presentations/g.test(url)) {
              return 'presentation';
            }
            return null;
          };
          self.goToUser = function(user) {
            if (!user || !user._id) {
              return;
            }
            Application.navigation.goTo('/edit/users/' + user._id);
          };

          self.nextPage = function() {
            if (!self.filter.page) {
              self.filter.page = 0;
            }
            self.filter.page++;
            self.loadItems();
          };
          self.previousPage = function() {
            if (!self.filter.page || self.filter.page < 2) {
              self.filter.page = 2;
            }
            self.filter.page--;
            self.loadItems();
          };
          self.getLocation = function(user) {
            if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
              return user.linked_locations[0].name;
            }
            return '-----';
          };
          self.getDepartment = function(user) {
            if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
              return user.linked_departments[0].name;
            }
            return '-----';
          };

          self.contentType = self.parseUrl();
          self.filter['assigned_content.content_id'] = self.contentId;

          self.loadItems = function() {
            if (self.sortName === 'completed_date') {
              self.filter.sort += ',createdAt,' + self.sortOrder;
            }
            self.searchLoading = true;
            AdminAssignments.find(self.filter).$promise.then(function(items) {
              self.allowNext = true;
              self.allowPrevious = true;
              if (items.length < self.filter.per_page) {
                self.allowNext = false;
              }
              if (self.filter.page < 2) {
                self.allowPrevious = false;
              }
              self.assignments = items;
              self.searchLoading = false;
            });
          };
          self.slimDate = function(date) {
            return moment(new Date(date)).format('D-MMM-YYYY h:mm a');
          };
          self.timeSpent = function(seconds_spent) {
            var seconds = parseInt(seconds_spent, 10);

            var days = Math.floor(seconds / (3600 * 24));
            seconds -= days * 3600 * 24;
            var hrs = Math.floor(seconds / 3600);
            seconds -= hrs * 3600;
            var mnts = Math.floor(seconds / 60);
            seconds -= mnts * 60;
            if (days > 0) {
              return days + " days, " + hrs + " Hrs, " + mnts + " Minutes, " + seconds + " Seconds";
            }
            if (hrs > 0) {
              return hrs + " Hrs, " + mnts + " Minutes, " + seconds + " Seconds";
            }
            if (mnts > 0) {
              return mnts + " Minutes, " + seconds + " Seconds";
            }
            return seconds + " Seconds";
          };
          self.changeSort = function(name) {
            self.filter.page = 0;
            if (self.sortName !== name) {
              self.sortOrder = -1;
            }
            if (self.sortName === name) {
              self.sortOrder = self.sortOrder * -1;
            }
            self.sortName = name;
            self.filter.sort = self.sortName + ',' + self.sortOrder;
            self.nextPage();
          };
          self.initialize = function() {
            if (!self.contentId || !self.contentType) {
              Application.navigation.goToHome();
              return;
            }
            var type = self.contentType === 'video' || self.contentType === 'file' ? 'media' : self.contentType;
            self.searchItems.csv_filtered = Application.API + '/learn/v3/assignments/csv?authtoken=' + Authorization.getAuthToken().authtoken + '&content_type=' + type + '&content_id=' + self.contentId;
            self.assignments = [];
            self.nextPage();
          };

          self.remindUser = function(id) {
            Assignments.remind({remindid: id}, null).$promise.then(function(success) {
              Application.messaging.addMessage({type: 'succes', text: self.translations['contentHostAssign.reminder_sent'], duration: 5});
            }).catch(function(error) {
              Application.messaging.addMessage({type: 'error', text: self.translations['contentHostAssign.error_sending_issue'], duration: 5});
            });
          };

          self.assignmentRemoval = {
            active: null,
            set: function(assignment) {
              this.active = assignment;
            },
            onDelete: function() {
              this.active = null;
              self.loadItems();
            }
          };

          self.initialize();

          $translate([
            'contentHostAssign.search_placeholder',
            'contentHostAssign.reminder_sent',
            'contentHostAssign.error_sending_issue'
          ]).then(function (translations) {
            self.translations = translations;
          });

        }],
      controllerAs: 'hostAssign'
    };
  }]);
